/**
 * A toast's own button (Undo) sits outside any open dialog or sheet. A modal
 * Radix layer treats a press there as an outside click and closes itself, so
 * this handler, given to the content's `onPointerDownOutside` and
 * `onInteractOutside`, lets a press on the toaster through and leaves the layer
 * open; `index.css` turns the toaster's pointer events back on under the modal.
 */
export function keepOpenForToasts<E extends { target: EventTarget | null; preventDefault: () => void }>(
  handler?: (event: E) => void,
): (event: E) => void {
  return (event) => {
    if (event.target instanceof Element && event.target.closest("[data-sonner-toaster]")) {
      event.preventDefault();
      return;
    }
    handler?.(event);
  };
}
